import { IconProps } from './iconTypes';

export const AI = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width={24} height={24} viewBox="0 0 16 16" {...props}>
        <path
            d="M15.0321 7.27566C11.7567 5.8836 10.2055 4.39383 8.81677 1.1795C8.28938 -0.126983 7.84511 -0.564749 7.21194 0.995457C5.82697 4.3196 4.17378 5.90405 0.918776 7.27566C0.591613 7.42638 0.00377786 7.68919 0 7.99972C0.00377786 8.311 0.588591 8.57306 0.918776 8.72378C4.17 10.0916 5.82697 11.6798 7.21194 15.004C7.85266 16.5922 8.29845 16.0931 8.81677 14.8199C10.2055 11.6071 11.7567 10.1166 15.0321 8.72378C15.3751 8.56018 15.9426 8.34281 16 8.01638V7.97927C15.9426 7.65587 15.3797 7.43547 15.0321 7.27188V7.27566Z"
            fill={color}
        />
    </svg>
);
